import { userConstants } from '../_constants';

let user = JSON.parse(localStorage.getItem('user'));
const initialState = user ? { loggedIn: true, user } : {};

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        user: action.user
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        loggedIn: true,
        user: action.user
      };
    case userConstants.LOGIN_FAILURE:
      return {};


    case userConstants.FORGOT_PASSWORD_REQUEST:
      return {
        loggingIn: true,
        user: action.user
      };
    case userConstants.FORGOT_PASSWORD_SUCCESS:
      return {
        loggedIn: true,
        forgotPassword: action.user.forgotPassword
      };
    case userConstants.FORGOT_PASSWORD_FAILURE:
      return {};



    case userConstants.OTP_FORGOT_PASSWORD_REQUEST:
      return {
        loggingIn: true,
        user: action.user
      };
    case userConstants.OTP_FORGOT_PASSWORD_SUCCESS:
      return {
        loggedIn: true,
        forgotUpdatePassword: action.user.forgotUpdatePassword
      };
    case userConstants.OTP_FORGOT_PASSWORD_FAILURE:
      return {};




    case userConstants.LOGIN_LANDLORD_REQUEST:
      return {
        loggingIn: true,
        user: action.user
      };
    case userConstants.LOGIN_LANDLORD_SUCCESS:
      return {
        loggedIn: true,
        user: action.user
      };
    case userConstants.LOGIN_LANDLORD_FAILURE:
      return {};
    case userConstants.LOGOUT:
      return {};
    default:
      return state
  }
}